export const userProfileSelector = (state: any) => state.user.userProfile;
